import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { BaseModalComponent, type ModalSize } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-confirmation-modal',
  imports: [BaseModalComponent, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  private readonly transloco = inject(TranslocoService);

  title = input<string>(this.transloco.translate('modalsConfirmTitle'));
  message = input<string>(this.transloco.translate('modalsConfirmMessage'));
  confirmText = input<string>(this.transloco.translate('commonButtonsConfirm'));
  cancelText = input<string>(this.transloco.translate('commonButtonsCancel'));
  isDestructive = input<boolean>(false);
  size = input<ModalSize>('medium');
  isLoading = input<boolean>(false);
  showCloseButton = input<boolean>(false);
  closeOnBackdropClick = input<boolean>(false);
  confirm = output<void>();
  cancel = output<void>();

  protected onConfirm(): void {
    if (!this.isLoading()) {
      this.confirm.emit();
    }
  }

  protected onCancel(): void {
    if (!this.isLoading()) {
      this.cancel.emit();
    }
  }
}
